import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';

@Injectable()
export class SaleDC {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private sampleUrl  = 'api/sample';
    private dcUrl  = 'api/dc';
    private woUrl  = 'api/workorder';
    private comboUrl  = 'api/combo';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    dcList(userData: any): Promise<any[]> {
    
        const url = `${this.dcUrl}/dcList`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    
    dcAutoNumber(userData: any): Promise<any[]> {
    
        const url = `${this.dcUrl}/dcAutoNumber`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

       save(userData: any): Promise<any[]> {
    
        const url = `${this.sampleUrl}/save`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getOpenWorkOrder(query: any): Promise<any[]> {
    
       let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.woUrl}/getOpenWorkOrder`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getWorkorderDesign(query: any): Promise<any[]> {
      let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.woUrl}/getWorkorderDesign`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getDesignColorList(userData: any): Promise<any[]> {
      const url = `${this.comboUrl}/getDesignColorList`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

      addDc(userData: any): Promise<any[]> {
      const url = `${this.dcUrl}/addDc`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    loadDC(userData: any): Promise<any[]> {
      const url = `${this.dcUrl}/loadDC`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
     deleteDc(userData: any): Promise<any[]> {
      const url = `${this.dcUrl}/deleteDc`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

     print(partyData: any): Promise<any> {
        const url = `http://localhost/barcode/api/print1`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    delete(userData: any): Promise<any[]> {
    
        const url = `${this.sampleUrl}/delete`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
  
    private handleError(error: any): Promise<any> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/services/salesDc.service.ts